const domain = {
    status: {
        connecting: 'در حال اتصال...',
        in_use: 'در حال استفاده',
        failed_to_connect: 'اتصال ناموفق بود',
    },
    update_endpoint_notice: 'فراموش نکنید که دامنه را برای URI بازگشتی اتصال‌دهنده اجتماعی و نقطه پایانی Logto در برنامه‌تان به‌روز کنید اگر می‌خواهید از دامنه سفارشی برای این ویژگی‌ها استفاده کنید.',
    error_hint: 'مطمئن شوید که رکوردهای DNS خود را به‌روز کرده‌اید. ما هر {{value}} ثانیه یک‌بار بررسی را ادامه خواهیم داد.',
    custom: {
        custom_domain: 'دامنه‌های سفارشی',
        custom_domain_description: 'با استفاده از یک دامنه سفارشی، برند خود را بهبود بخشید. این دامنه در تجربه ورود شما استفاده خواهد شد.',
        custom_domain_field: 'دامنه‌های سفارشی',
        custom_domain_placeholder: 'auth.domain.com',
        add_custom_domain_field: 'افزودن دامنه سفارشی',
        custom_domains_field: 'دامنه‌های سفارشی',
        add_domain: 'افزودن دامنه',
        invalid_domain_format: 'لطفاً یک URL دامنه معتبر با حداقل سه بخش وارد کنید، مثلاً "auth.domain.com".',
        verify_domain: 'تأیید دامنه',
        enable_ssl: 'فعال‌سازی SSL',
        checking_dns_tip: 'پس از پیکربندی رکوردهای DNS، فرآیند به‌صورت خودکار اجرا می‌شود و ممکن است تا ۲۴ ساعت طول بکشد. می‌توانید این رابط را در حین اجرا ببندید.',
        enable_ssl_tip: 'فعال‌سازی SSL به‌صورت خودکار اجرا می‌شود و ممکن است تا ۲۴ ساعت طول بکشد. می‌توانید این رابط را در حین اجرا ببندید.',
        generating_dns_records: 'در حال تولید رکوردهای DNS...',
        add_dns_records: 'لطفاً این رکوردهای DNS را به ارائه‌دهنده DNS خود اضافه کنید.',
        dns_table: {
            type_field: 'نوع',
            name_field: 'نام',
            value_field: 'مقدار',
        },
        deletion: {
            delete_domain: 'حذف دامنه',
            reminder: 'حذف دامنه سفارشی',
            description: 'آیا مطمئن هستید که می‌خواهید این دامنه سفارشی را حذف کنید؟',
            in_used_description: 'آیا مطمئن هستید که می‌خواهید این دامنه سفارشی "<span>{{domain}}</span>" را حذف کنید؟',
            in_used_tip: 'اگر قبلاً این دامنه سفارشی را در ارائه‌دهنده اتصال‌دهنده اجتماعی یا نقطه پایانی برنامه‌تان تنظیم کرده‌اید، باید URI را به دامنه پیش‌فرض Logto "<span>{{domain}}</span>" تغییر دهید. این برای عملکرد صحیح دکمه ورود اجتماعی ضروری است.',
            deleted: 'دامنه سفارشی با موفقیت حذف شد!',
        },
        config_custom_domain_description: 'دامنه‌های سفارشی را برای راه‌اندازی ویژگی‌های زیر پیکربندی کنید: برنامه‌ها، اتصال‌دهنده‌های اجتماعی و اتصال‌دهنده‌های سازمانی.',
    },
    default: {
        default_domain: 'دامنه پیش‌فرض',
        default_domain_description: 'Logto یک دامنه پیش‌فرض از پیش پیکربندی‌شده ارائه می‌دهد که بدون نیاز به تنظیمات اضافی آماده استفاده است. این دامنه پیش‌فرض حتی اگر دامنه سفارشی فعال کرده باشید، به عنوان گزینه پشتیبان عمل می‌کند.',
        default_domain_field: 'دامنه پیش‌فرض Logto',
    },
    custom_endpoint_note: 'می‌توانید نام دامنه این نقاط پایانی را بر اساس نیاز خود سفارشی کنید. یکی از "{{custom}}" یا "{{default}}" را انتخاب کنید.',
    custom_social_callback_url_note: 'می‌توانید نام دامنه این URI را برای تطابق با نقطه پایانی برنامه‌تان سفارشی کنید. یکی از "{{custom}}" یا "{{default}}" را انتخاب کنید.',
    custom_acs_url_note: 'می‌توانید نام دامنه این URI را برای تطابق با URL سرویس مصرف‌کننده اثبات هویت ارائه‌دهنده هویت خود سفارشی کنید. یکی از "{{custom}}" یا "{{default}}" را انتخاب کنید.',
    switch_custom_domain_tip: 'دامنه خود را تغییر دهید تا نقطه پایانی مربوطه را مشاهده کنید. از طریق <a>دامنه‌های سفارشی</a> دامنه‌های بیشتری اضافه کنید.',
    switch_saml_app_domain_tip: 'دامنه خود را تغییر دهید تا URLهای مربوطه را مشاهده کنید. برای پروتکل‌های SAML، URLهای متادیتا می‌توانند روی هر دامنه قابل دسترسی میزبانی شوند. با این حال، دامنه انتخاب‌شده URL سرویس SSO را تعیین می‌کند که SP‌ها از آن برای هدایت کاربران نهایی برای احراز هویت استفاده می‌کنند، که بر تجربه ورود و نمایش URL تأثیر می‌گذارد.',
    switch_saml_connector_domain_tip: 'دامنه‌ها را تغییر دهید تا URLهای مربوطه را مشاهده کنید. دامنه انتخاب‌شده ACS URL شما را تعیین می‌کند، که بر مکان هدایت کاربران پس از ورود SSO تأثیر می‌گذارد. دامنه‌ای را انتخاب کنید که با رفتار تغییر مسیر مورد انتظار برنامه شما مطابقت دارد.',
};
export default Object.freeze(domain);
